import { createPublicClient } from '../../../../app/infrastructure/http/apiClient';
import type { ListResponse } from '../../../../app/types/list-response';
import type { MentorCatalogPage, MentorListItem } from '../../application/types';

export async function fetchTopMentors(): Promise<MentorListItem[]> {
  const response = await createPublicClient().get<{
    data: ListResponse<MentorListItem>;
  }>('/mentors', {
    params: { page: 1, limit: 20, isTop: true, status: 'published' },
  });
  return response.data?.data?.list ?? [];
}

export function fetchMentorCatalog(params: {
  limit?: number;
  cursor?: string | null;
  categoryId?: number | null;
}): Promise<MentorCatalogPage> {
  return createPublicClient()
    .get<{ data: MentorCatalogPage }>('/public/mentors/catalog', {
      params: {
        limit: params.limit ?? 6,
        cursor: params.cursor || undefined,
        categoryId: params.categoryId ?? undefined,
      },
    })
    .then((response) => response.data.data);
}

let publishedMentorsRequest: Promise<MentorListItem[]> | null = null;

export function fetchPublishedMentors(): Promise<MentorListItem[]> {
  if (!publishedMentorsRequest) {
    publishedMentorsRequest = createPublicClient()
      .get<{ data: ListResponse<MentorListItem> }>('/mentors', {
        params: { page: 1, limit: 100, status: 'published' },
      })
      .then((response) => response.data?.data?.list ?? [])
      .catch((error) => {
        publishedMentorsRequest = null;
        throw error;
      });
  }
  return publishedMentorsRequest;
}
